import React from "react";
import { ReactComponent as Logo } from "../../images/360-grassroots.svg";
import TopNav from "./TopNav";
import { useLocation, Link } from "react-router-dom";

const Header: React.FC = () => {
    const location = useLocation();

    const scrollToSection = (id: string) => {
        const section = document.getElementById(id);
        if (section) {
            const scrollOffset = 0; // Adjust for sticky header height if needed
            const finalScrollPosition = section.offsetTop + scrollOffset;

            window.scrollTo({
                top: finalScrollPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <header>
            <section className="container" id="home">
                <div className="col-12-xs col-3-md">
                    {location.pathname === "/" ? (
                        <button onClick={() => scrollToSection("home")} className="logo">
                            <Logo className="logo" />
                        </button>
                    ) : (
                        <Link to="/" className="logo">
                            <Logo className="logo" />
                        </Link>
                    )}
                </div>
                <div className="col-12-xs col-9-md">
                    <TopNav />
                </div>
            </section>
        </header>
    );
};

export default Header;
